import { createContext } from 'react';

export type BalanceVisibilityType = {
  isBalanceHidden: boolean;
  setIsBalanceHidden: React.Dispatch<React.SetStateAction<boolean>>;
};

export const BalanceVisibilityContext = createContext<BalanceVisibilityType>(
  {} as BalanceVisibilityType
);
export const BalanceVisibilityContextProvider =
  BalanceVisibilityContext.Provider;
